<template>
	<div>
		<ihead :checkindex="checkindex"></ihead>
		<div class="banner-box">
			<h1>{{ title }}</h1>
		</div>
    <mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item
					v-for="(item, index) in items"
					:key="index"
					:to="item.to"
					:disabled="item.disabled"
					>{{ item.text }}</mu-breadcrumbs-item
				>
			</mu-breadcrumbs>
		</mu-container>
		<iside :subtitle='title' :mainid='mainid' :subid='subid' :contentList='contentList' :topList='topList'></iside>
		<pagination :total="total" :current-page='current' @pagechange="pagechange"></pagination>
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>

<script>
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import iside from '@/components/sidebar.vue'
import crumbs from "@/components/crumbs.vue"
import pagination from '@/components/pagination'
import returntop from '@/components/returntop'

export default {
components: {
		ihead, ifoot, iside, crumbs, pagination, returntop
},
data (){
	return {
		title: "",
		checkindex:5,
		items: [
			{
				text: "首页",
				to: "/",
				disabled: false
			},
			{
				text: "",
				disabled: true
			},
			{
				text: "",
				disabled: true
			}
		],
		id:this.$route.query.id,
		mainid: this.$route.query.mainid,
    	subid: this.$route.query.subid,
		total: 0,     // 记录总条数
		display: 10,   // 每页显示条数
		current: 1,   // 当前的页数
		contentList:[],
		topList:[{
			picture:{path:''},
			title:'',
			content: "",
			// times:'2019-12-27 16:49:00'
		}]
	}
},
	watch: {
      $route(to, from) {		 
			this.id = to.query.id
			this.subid = to.query.subid
			this.mainid = to.query.mainid
			this.getContentList(1,10)
			this.getNav()
			this.getTop5()
		}
	},
	created(){
		this.getContentList(1,10)
		this.getTop5()
		this.getNav()
	},
	methods: {
			pagechange:function(currentPage){
			this.getContentList(currentPage, 10)
		},
		getContentList(page,offset){
			var data = {
				cid:this.id,
				page:page,
				offset:offset
			}	
			this.$get('/article/get-article-list-by-cid', data).then(res => {
				if(res.code == 0){
					let data = res.data;
					this.contentList = data.data
					this.total = Math.ceil(data.totalCount / 10)
					for(let i = 0;i<data.data.length;i++){
						data.data[i].times =  this.$getData(data.data[i].create_time)
					}
				}else{
					// console.log(res.message)
				}
			})
		},
		getTop5(){
			this.$get('/article/get-article-rank',{cid:this.id}).then(res => {
				if(res.code == 0){
					var data = res.data;
					this.topList = data.data
				}else{
					// console.log(res.message)
				}
			})
		},
		getNav() {
			this.$get("/nav/get-nav-tree").then(res => {
				if (res.code === 0) {
				let data = res.data;
				// console.log(data)
				if (data) {
					let newData = data.filter((item, index, array) => {
					return item.id === this.mainid;
					});
					this.$set(this.items[1], "text", newData[0].text);
					if (newData[0].children) {
					let subData = newData[0].children;
					let newSubData = subData.filter((item, index, array) => {
						return item.id === this.subid;
					});
					this.$set(this.items[2], "text", newSubData[0].text);
					this.title = newSubData[0].text;
					}
				}
				} else {
				// console.log(res.message);
				}
			})
		}
	},
}
</script>

<style>
.banner-box {
    background-image: url('../assets/page-title-bg.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 90px 0 90px;    
}
.banner-box h1{
    font-size: 48px;
    margin-bottom: 15px;
    text-transform: uppercase;
    font-weight: 800;
    color: #eeeeee;
}
@media screen and ( max-width: 768px){
	.sidebar .contain{
		width: 100%;
		margin: 0;
	}
	.sidebar .side-left{
		display: none;
	}
	.sidebar .contain-min li img{
		width: 25%;
		height: 50%;
	}
	.sidebar .contain-min .contain-right{
		width: 70%;
	}
	.sidebar .contain-min li{
		width: 100%;
		height: 200px;		
		box-shadow: none;
	}
}
@media screen and ( max-width: 320px) {	
	.sidebar .contain-min .contain-right #contens{
		height: 60px;
		-webkit-line-clamp:3;
	}		
}
</style>
